import React, { useState } from "react";
import { ListGroupItem, Offcanvas, OffcanvasHeader } from "reactstrap";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import { ButtonPrimarySmall } from "../style/Button";
import { Link } from 'react-router-dom';
import styled from "styled-components";
import { PopupButton } from '@typeform/embed-react'

function TimelineCard(args) {
  const [canvasInventaire, setCanvasInventaire] = useState(false);
  const toggleInventaire = () => setCanvasInventaire(!canvasInventaire);
  const [openObligLegale, setOpenObligLegale] = useState(false);
  


  const QuestionnaireConnaissanceSubmit = (event) => {
    //console.log("QuestionnaireAcheteurSubmit",args.action);
    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/actions/${args.action}`;
    //on update le statut de l'action
    fetch(
      URL,
      {
        method: "PATCH",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
          "Accept": "application/json",
          'content-type': "application/json"
        },
        body: JSON.stringify({
          "fields": {
            "statut": "fait"
          }
        })
      })
      .then((res) => res.json())
      .then((res) => { window.location.reload(true); })

  }
  const QuestionnaireEtatCivil = (id) => {
    //console.log("QuestionnaireAcheteurSubmit",args.action);
    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/actions/${id}`;
    //on update le statut de l'action
    fetch(
      URL,
      {
        method: "PATCH",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
          "Accept": "application/json",
          'content-type': "application/json"
        },
        body: JSON.stringify({
          "fields": {
            "statut": "fait"
          }
        })
      })
      .then((res) => res.json())
      .then((res) => { window.location.reload(true); })

  }

  const InfoBeneficiaire = (event) => {
    //console.log("DoneAction",id);
    const URL = `https://api.airtable.com/v0/appD48APNaGA4GN0B/actions/${args.action}`;
    //on update le statut de l'action
    fetch(
      URL,
      {
        method: "PATCH",
        headers: {
          Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
          "Accept": "application/json",
          'content-type': "application/json"
        },
        body: JSON.stringify({
          "fields": {
            "statut": "fait"
          }
        })
      })
      .then((res) => res.json())
      .then((res) => { window.location.reload(true); })

  }
  
  console.log("args action", args)

  return (
    <>
      <ListGroupItemS className={args.statut}>

        {/***************** COMPOSANT COMMUN A PLUSIEURS DÉMARCHES *********************/}
        {/** Composant de questionnaire **/}
        {args.type === "questionnaire" && 
          <>
            <ListGroupS>
              <h4 className="mb-2 type">
                Renseignez votre questionnaire client
                <br />
              </h4>
              <div className="flex-grow-1 content">
                {args.statut === "à faire" ? (
                  <>
                    <p>
                      Le questionnaire est nécessaire à la rédaction de vos documents notariés.
                    </p>
                    {args.user.role === "vendeur" ? (<>
                      <PopupButton
                        id="rvzO0MOV"
                        className="mt-2 btn-main"
                        hidden={{ user_id: args.user.airtable_id, id_action: args.action, }}
                        autoClose={true}
                        onSubmit={QuestionnaireConnaissanceSubmit}
                      >
                        Remplissez votre questionnaire
                      </PopupButton>
                    </>
                    ) : (<>{
                      <PopupButton
                        id="IZAUWQhO"
                        className="mt-2 btn-main"
                        hidden={{ user_id: args.user.airtable_id, id_action: args.action }}
                        autoClose={true}
                        onSubmit={QuestionnaireConnaissanceSubmit}
                      >
                        Remplissez votre questionnaire 
                      </PopupButton>
                    }</>)}
                  </>
                ) : (<>{""}</>)}
                {args.statut === "fait" ? (
                  <>
                    <p>
                      C'est tout bon, merci de nous avoir communiqué vos infos 🙂
                    </p>
                  </>
                ) : (<>{""}</>)}
              </div>

            </ListGroupS>
          </>
        }

        {/** Composant de document **/}
        {args.type === "document" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Ajoutez vos documents
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" ? (
                  <>
                    <p>
                      Pour débuter les démarches, votre notaire a besoin de documents, ajoutez-les le plus tôt possible.
                    </p>
                    {args.demarche === "pacs" && <><Link to="/app/document-pacs"  className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link></>}
                    {args.demarche === "mariage" && <><Link to="/app/document-mariage"  className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link></>}
                    {args.demarche === "pma" && <><Link to="/app/document-pma"  className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link></>}
                    {args.demarche === "immobilier" && <><Link to="/app/document"  className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link></>}
                    
                  </>
                ) : (<>{""}</>)}
                {args.statut === "fait" && <>
                  <p>
                      Merveilleux tout vos documents ont été ajoutés sur la plateforme. Merci :)
                    </p>
                </> }
              </div>

            </ListGroupS>
          </>
        }

        {/** Composant de choix de notaire **/}
        {args.type === "notaire" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Choisissez votre notaire
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                     Pour fixez votre 1er rendez-vous vous devez choisir le notaire
                    </p>
                    <Link  to={`/app/notaires/${args.demarche}/${args.id_affaire}`} className="no-underline btn-main mt-3 mr-3"> Choisissez votre notaire</Link>
                  </>
                }
                {args.statut === "fait" &&
                    <p>
                      Votre affaire a été prise en charger
                    </p>
                }
              </div>

            </ListGroupS>
          </>
          }

          {/** Composant de paiement prestation CLOTERE **/}
        {args.type === "paiementPrestation" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Payez vos honoraires
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                     {args.demarche === "mariage" && <>Votre contrat de mariage coûte 369€. <br/>Si des apports sont ajoutés à votre contrat, des honoraires notaire vous seront facturés ensuite.</>}
                     {args.demarche === "pacs" && <>Votre convention de pacs chez le notaire coûte 290€. <br/>Si des clauses ou conditions spécifiques sont ajoutées à votre contrat, des honoraires notaire vous seront facturés ensuite.</>}
                    </p>

                    {args.lienPaiement ? <a   href={args.lienPaiement + "?prefilled_email=" + args.email}  target="blank" className="no-underline btn-main mt-3 mr-3"> Payez maintenant</a> : <p className="text-gray-300">Lien de paiement non disponible</p>}
                    
                  </>
                }
                {args.statut === "fait" &&
                    <p>
                      Votre paiement a bien été effectué
                    </p>
                }
              </div>

            </ListGroupS>
          </>
          }

          {/** Composant de paiement DES HONORAIRES NOTAIRE  **/}
        {args.type === "paiementHonoraire" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Payez vos honoraires notaire
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Votre notaire vous demande des honoraires pour réaliser votre acte notarié
                    </p>

                    <a href={args.lienPaiement + "?prefilled_email=" + args.email}  target="blank" className="no-underline btn-main mt-3 mr-3"> Voir les honoraires</a>
                    
                  </>
                }
                {args.statut === "fait" &&
                    <p>
                      Votre affaire a été prise en charge
                    </p>
                }
              </div>

            </ListGroupS>
          </>
          }



        {/** Composant de rib **/}
        {args.type === "rib" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Ajoutez votre RIB
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" ? (
                  <>
                    <p>
                      Afin de sécuriser les futures transactions, il faut ajouter vos informations bancaires avec une double authentification.
                    </p>
                    <p><i>Votre notaire n'a pas encore demandé votre RIB</i></p>
                    {/*<button disabled className="btn-main mt-3 mr-3"> Ajoutez votre RIB</button>*/}
                  </>
                ) : (<>{""}</>)}
                {args.statut === "fait" ? (
                  <>
                    <p>
                      Vos données bancaires ont bien été transmises de manière sécurisée.
                    </p>
                  </>
                ) : (<>{""}</>)}
              </div>

            </ListGroupS>
          </>
        }

        {/** Composant de rdv **/}
        {args.type === "rdv" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Organisez vos rendez-vous de vente
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" ? (
                  <>
                    <p>
                      Votre notaire indiquera ses disponibilités et vous pourrez indiquer les votres par la suite. vous serez averti(e) lorsqu'il faudra donner vos disponibilités.
                    </p>

                  </>
                ) : (<>{""}</>)}
                {args.statut === "en cours" ? (
                  <>
                    <p>
                      Deux rendez-vous majeurs vous attendent pendant votre transaction. Le 1er pour la signature de la promesse de vente et le second, celui de la signature de l'acte de vente authentique.
                      <br />Votre notaire renseigne ses disponibilités et vous pourrez indiquer les votres par la suite.
                    </p>
                    <ButtonPrimarySmall color="primary" href="#" target="blank" className="mt-3 mr-3"> Indiquez vos disponibilités</ButtonPrimarySmall>
                  </>
                ) : (<>{""}</>)}
              </div>

            </ListGroupS>
          </>
        }

        {/** Composant de inventaire vendeur **/}
        {args.type === "inventaireImmo" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Faites l’inventaire des meubles
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" ? (
                  <><p>Pourquoi ? Un inventaire du mobilier annexé lors du compromis de vente peut permettre de réduire les frais de notaire de l'acquéreur. C'est pour cette raison que le vendeur doit réaliser l'inventaire des meubles de son bien.</p>
                    <Link to={`/app/inventaire/immo/${args.action.id}`} type="immo"  className="btn-main mt-3 mr-3 no-underline w-content"> Faire mon inventaire</Link>
                  </>
                ) : (<>{""}</>)}
                {args.statut === "fait" ? (
                  <p>
                    👍 C'est tout bon, nous avons bien enregistrer votre inventaire merci.
                  </p>
                ) : (<>{""}</>)}
              </div>

            </ListGroupS>
          </>
        }

        {/***************** COMPOSANTS DONATION **********************/}
        {/** Composant de document **/}
        {args.type === "documentdonation" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Ajoutez vos documents
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Pour débuter les démarches, votre notaire a besoin de documents, ajoutez-les le plus tôt possible.
                    </p>
                    <Link to="/app/document-donation" className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux tout vos documents ont été ajoutés sur la plateforme. Merci :)
                    </p>
                  </>
              }
              </div>

            </ListGroupS>
          </>
        }
        {/** Composant info beneficiaire **/}
        {args.type === "infobeneficiaire" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Renseignez les informations des bénéficiaires
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" &&
                  <><p>Ces informations sont nécessaires à la rédaction des actes de donation </p>
                    <PopupButton
                      id="FJDTvJHQ"
                      className="mt-2 btn-main"
                      hidden={{ donation_id: args.donation, id_action: args.action, }}
                      autoClose={true}
                      onSubmit={InfoBeneficiaire}
                    >
                      Renseigner les informations
                    </PopupButton>
                  </>
                }
                {args.statut === "fait" &&
                  <p>
                    👍 C'est tout bon, merci pour ces informations.
                  </p>
                }
              </div>

            </ListGroupS>
          </>
        }
        {/** Composant inventaire meuble beneficiaire **/}
        {args.type === "inventaire" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Faites l’inventaire des meubles
                <br />
              </h4>
              <div className="flex-grow-1 content">

                {args.statut === "à faire" &&
                  <><p>Listez les meubles et décoration de votre bien pour en établir la valeur</p>
                    <button className="btn-main" onClick={toggleInventaire}>Faire mon inventaire</button>
                  </>
                }
                {args.statut === "fait" &&
                  <p>
                    👍 C'est tout bon, merci pour ces informations.
                  </p>
                }
              </div>

            </ListGroupS>
          </>
        }


        {/***************** COMPOSANTS PMA **********************/}
        {/** Composant de questionnaire etat civil **/}
        {args.type === "etatCivilPma" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Remplissez votre questionnaire d'état civil
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Pour débuter les démarches, votre notaire a besoin de quelques informations.
                    </p>
                    <PopupButton
                      id="cjnWQ7jk"
                      className="mt-2 btn-main"
                      hidden={{ demarche_id: args.action.id, type: "pma" }}
                      autoClose={true}
                      onSubmit={() => QuestionnaireEtatCivil(args.action.id)}
                    >
                      Remplissez votre questionnaire
                    </PopupButton>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux nous avons bien toutes vos informations. Merci :)
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }
        {/** Composant de document **/}
        {args.type === "documentPma" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Ajoutez vos documents
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Les documents sont cruciaux pour votre dossier, ajoutez-les le plus tôt possible.
                    </p>
                    <Link to="/app/document-pma"  className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux tout vos documents ont été ajoutés sur la plateforme. Merci :)
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }

        {/** Composant paiement **/}
        {args.type === "paiementPma" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Paiement de votre prestation
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                  {/** cas femme seule et couple hétéro */}
                  {args.typePma === "seule" &&
                    <p>
                      Seul le consentement à la PMA, est nécessaire dans votre situation. <br/><b>Le prix de cet acte notarié est de 189€</b>.
                      <br/>
                      Cette somme couvre la totalité de la démarche chez le notaire, et vous garantie d'obtenir vos documents notariés conformes à la législation.
                    </p>
                    } 
                    {args.typePma === "couplehetero" &&
                    <p>
                      Seul le consentement à la PMA, est nécessaire dans votre situation. <br/><b>Le prix de cet acte notarié est de 189€</b>.
                      <br/>
                      Cette somme couvre la totalité de la démarche chez le notaire, et vous garantie d'obtenir vos documents notariés conformes à la législation.
                    </p>
                    } 
                    {/** cas couple homo */}
                  {args.typePma === "couplehomo" &&
                    <p>
                      Deux actes sont nécessaires dans votre situation. <br/><b>Le prix de ces actes notariés est de 378€</b>.
                      <br/>
                      Cette somme couvre la totalité de la démarche chez le notaire, et vous garantie d'obtenir vos documents notariés conformes à la législation.
                    </p>
                    } 
                    <a href={args.lienPaiement + "?prefilled_email=" + args.email} target="blank" className="btn-main mt-3 mr-3 no-underline w-content"> Payez vos actes notariés</a>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Votre paiement a bien été enrgistré. Vous recevrez votre facture par mail.
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }

        {/** Composant oblig légales **/}
        {args.type === "lectureObligationsLegales" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Prendre connaissance de vos obligations légales
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Prenez connaissance des obligations légales importantes de votre démarche
                    </p>
                    <button onClick={() => setOpenObligLegale(true)} className="btn-main mt-3 mr-3 no-underline w-content"> Lire mes obligations</button>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux tout vos documents ont été ajoutés sur la plateforme. Merci :)
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }

        {/***************** COMPOSANTS MARIAGE **********************/}
        {/** Composant de questionnaire etat civil **/}
        {args.type === "etatCivilMariage" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Remplissez votre questionnaire d'état civil
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Pour débuter les démarches, votre notaire a besoin de quelques informations.
                    </p>
                    <PopupButton
                      id="cIo8sPVO"
                      className="mt-2 btn-main"
                      hidden={{ demarche_id: args.action.id, type: "mariage" }}
                      autoClose={true}
                      onSubmit={() => QuestionnaireEtatCivil(args.action.id)}
                    >
                      Remplissez votre questionnaire
                    </PopupButton>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux nous avons bien toutes vos informations. Merci :)
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }
        {/** Composant de document **/}
        {args.type === "documentMariage" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Ajoutez vos documents
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Les documents sont cruciaux pour votre dossier, ajoutez-les le plus tôt possible.
                    </p>
                    <Link to="/app/document-mariage" className="btn-main mt-3 mr-3 no-underline w-content"> Ajoutez vos documents</Link>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux tout vos documents ont été ajoutés sur la plateforme. Merci :)
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }
        {/** Composant de liste de bien mariage **/}
        {args.type === "listeBienMariage" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Listez vos biens mobiliers et immobiliers
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Les biens ont une importance capitale dans la rédaction de votre contrat de mariage, et peuvent engendrer des coûts de formalités supplémentaires, listez les au plus tôt.
                    </p>
                    <Link to={`/app/inventaire/mariage/${args.action.id}`} type="mariage"  className="btn-main mt-3 mr-3 no-underline w-content"> Listez vos biens</Link>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Nous avons bien enregistré les informormations, Merci 🙂
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }


         {/***************** COMPOSANTS PACS **********************/}
        {/** Composant de questionnaire etat civil **/}
        {args.type === "etatCivilPacs" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Remplissez votre questionnaire d'état civil
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Pour débuter les démarches, votre notaire a besoin de quelques informations.
                    </p>
                    <PopupButton
                      id="cIo8sPVO"
                      className="mt-2 btn-main"
                      hidden={{ demarche_id: args.action.id, type: "pacs" }}
                      autoClose={true}
                      onSubmit={() => QuestionnaireEtatCivil(args.action.id)}
                    >
                      Remplissez votre questionnaire
                    </PopupButton>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Merveilleux nous avons bien toutes vos informations. Merci :)
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }
        {/** Composant de liste de bien mariage **/}
        {args.type === "listeBienPacs" &&
          <>
            <ListGroupS className={args.etat + ' ' + args.etatcss}>
              <h4 className="mb-2 type">
                Listez vos biens mobiliers et immobiliers
                <br />
              </h4>
              <div className="flex-grow-1  content">

                {args.statut === "à faire" &&
                  <>
                    <p>
                      Les biens ont une importance capitale dans la rédaction de votre convention de PACS, et peuvent engendrer des coûts de formalités supplémentaires, listez les au plus tôt.
                    </p>
                    <Link to={`/app/inventaire/pacs/${args.action.id}`} type="pacs"  className="btn-main mt-3 mr-3 no-underline w-content"> Listez vos biens</Link>
                  </>
                }
                {args.statut === "fait" &&
                  <>
                    <p>
                      Nous avons bien enregistré les informormations, Merci 🙂
                    </p>
                  </>
                }
              </div>

            </ListGroupS>
          </>
        }

      </ListGroupItemS>


      {/** modal diag obligations légales*/}
      <Dialog open={openObligLegale} onClose={setOpenObligLegale} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-2xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div>
                <div className="">
                  <DialogTitle as="h3" className="text-lg font-semibold text-gray-900 mb-10">
                    Vos obligations légales
                  </DialogTitle>
                  <div>
                    <p className="text-base">
                     Votre notaire vous expliquera chaque point listé ci-dessous. <br/>
                     Vous pouvez cependant prendre connaissance de ces obligations légales afin de lister vos questions le jour de votre rendez-vous avec le notaire.
                     <br/>
                     <b>Voici les obligations légales :</b>
                    </p>
                    <ul>
                    <li>• Il ne sera pas possible d’établir un lien de filiation entre l’enfant et l’auteur du don ou d’agir en responsabilité à l’encontre de celui-ci </li>
                    <li>• Il ne sera pas possible d’exercer une action visant à établir ou à contester la filiation au nom de l’enfant (sauf à soutenir que l’enfant n’est pas issu de cette PMA),</li>
                    <li>• La possibilité de faire déclarer judiciairement la paternité hors mariage de celui qui n’a pas reconnu l’enfant qui en est issu</li>
                    <li>• Pour les couples de femmes, Il ne sera pas possible d'exercer une action contre celle qui s’oppose à la remise de la reconnaissance de déclaration conjointe au Service de l’Etat-Civil</li>
                    <li>• Il ne sera pas possible pour l’enfant à sa majorité, d’avoir accès aux données non identifiantes, et à l’identité du tiers donneur</li>
                    <li>• Les conséquences de l’acte de consentement à PMA, sur l’établissement de la filiation, le nom de famille, et l’exercice de l’autorité parentale</li>
                    <li>• Qu’en cas de parcours de PMA réalisé à l’étranger, l’enfant devenu majeur ne pourra avoir accès aux données concernant le tiers donneur que si le pays en question ne rend pas anonyme le tiers donneur.</li>
                                        
                 
                    </ul>
                  </div>
                </div>
              </div>
              <div className="mt-3">
                <button
                  type="button"
                  onClick={() => setOpenObligLegale(false)}
                  className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  J'ai compris
                </button>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>




    </>
  );
}


const ListGroupItemS = styled(ListGroupItem)`
  width:100%;
  padding:23px 23px;
  border-radius:8px;
  border:0;
  &.fait{
    opacity:.9;
    &:before{
        content: "✔️"!important;
        background-color:${props => props.theme.colors.main};
        color:white;
        border:0;
    }
}



`;

const ListGroupS = styled.div`
  width:100%;
  
  h4.type{
    display: inline-block;
    text-transform: lowercase;
    font-size:20px;
    font-weight:600;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  
`;



export default TimelineCard;